export const BLOCK_SUBTYPE_GRID = 'grid';
export const BLOCK_SUBTYPE_IMAGE = 'image';
export const BLOCK_SUBTYPE_VIDEO = 'video';
export const BLOCK_SUBTYPE_SUBPAGE = 'subpage';
export const BLOCK_SUBTYPE_GRID_BIO_ROUNDED = 'grid_bio_rounded';
export const BLOCK_SUBTYPE_GRID_BIO_ROUNDED_SINGLE = 'grid_bio_rounded_single';
export const BLOCK_SUBTYPE_GRID_BIO_STANDARD = 'grid_bio_standard';
export const BLOCK_SUBTYPE_GRID_BIO_STANDARD_SINGLE = 'grid_bio_standard_single';
export const BLOCK_SUBTYPE_GRID_HERO_LEFT_ALIGNED = 'grid_hero_left_aligned';
export const BLOCK_SUBTYPE_GRID_HERO_MIDDLE_ALIGNED = 'grid_hero_middle_aligned';
export const BLOCK_SUBTYPE_GRID_IMAGE_AND_TEXT_FULL_BLEED = 'grid_image_and_text_full_bleed';
export const BLOCK_SUBTYPE_GRID_IMAGE_AND_TEXT_BORDERED = 'grid_image_and_text_bordered';
export const BLOCK_SUBTYPE_GRID_VIDEO_AND_TEXT_FULL_BLEED = 'grid_video_and_text_full_bleed';
export const BLOCK_SUBTYPE_GRID_VIDEO_AND_TEXT_BORDERED = 'grid_video_and_text_bordered';

export const NON_DEFAULT_TILE_CREATOR_SUBTYPES = Object.freeze([
  BLOCK_SUBTYPE_IMAGE,
  BLOCK_SUBTYPE_VIDEO
]);